import { ReactElement, useState } from 'react'
import { useFormikContext } from 'formik'
import { Grid, H, P } from '@farewill/ui'

import RadioGroup from 'components/form/radio-group'
import { FuneralPlanLeadAttributes } from 'lib/models/lead'
import CrematoriumPicker from 'components/form/crematorium-picker'

const FORM_FIELDS_NAMES = {
  SELECT_CREMATORIUM: 'selectCrematorium',
  CREMATORIUM_ID: 'crematoriumId',
  CREMATORIUM: 'crematorium',
} as const

export const Crematoria = (): ReactElement => {
  const { values, handleSubmit, setFieldValue } =
    useFormikContext<FuneralPlanLeadAttributes>()

  const [showSelectCrematorium, setShowSelectCrematorium] = useState(
    values.quoteAttributes.selectCrematorium === 'true'
  )

  const [crematorium, setCrematorium] = useState(
    values.quoteAttributes.crematorium
  )

  const customerPostcode = values.contact?.addresses?.[0]?.postalCode

  const handleCrematoriumChange = ({ value }: { value: string }) => {
    setFieldValue(
      `quoteAttributes.${FORM_FIELDS_NAMES.SELECT_CREMATORIUM}`,
      value
    )
    if (value === 'true') {
      setShowSelectCrematorium(true)
      handleSubmit()

      return
    } else {
      setShowSelectCrematorium(false)
      /** reset the crematorium */
      resetCrematorium()
    }
  }

  const resetCrematorium = () => {
    setCrematorium(undefined)
    setFieldValue(`quoteAttributes.${FORM_FIELDS_NAMES.CREMATORIUM_ID}`, null)
    setFieldValue(`quoteAttributes.${FORM_FIELDS_NAMES.CREMATORIUM}`, null)
    handleSubmit()
  }

  return (
    <Grid.Item>
      <H size="S" margin={['XL', 0, 'S']}>
        Choose a crematorium
      </H>
      <Grid data-testid="choose-a-crematorium">
        <Grid.Item>
          <P>Would they like to choose where the cremation will take place?</P>
          <RadioGroup
            name={`quoteAttributes.${FORM_FIELDS_NAMES.SELECT_CREMATORIUM}`}
            handleSave={handleCrematoriumChange}
            options={[
              { label: 'Yes', value: 'true' },
              { label: 'No', value: 'false' },
            ]}
          />
        </Grid.Item>
        {showSelectCrematorium && (
          <CrematoriumPicker
            crematorium={crematorium}
            customerPostcode={customerPostcode}
            onReset={resetCrematorium}
            onCrematoriumChanged={(selectedCrematorium) => {
              setFieldValue(
                `quoteAttributes.${FORM_FIELDS_NAMES.CREMATORIUM_ID}`,
                selectedCrematorium.id
              )
              setFieldValue(
                `quoteAttributes.${FORM_FIELDS_NAMES.CREMATORIUM}`,
                selectedCrematorium
              )
              setCrematorium(selectedCrematorium)
              handleSubmit()
            }}
          />
        )}
      </Grid>
    </Grid.Item>
  )
}
